<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="callSubmit">
		<v-select required :items="roles" v-model="form.role" label="סוג משתמש"></v-select>
		<organizations-select v-model="form.organization_id" v-if="isAdmin && form.role == 2"/>
		<smart-input required :error="inputErrors.name" label='שם פרטי' v-model="form.name"></smart-input>
		<smart-input :error="inputErrors.last_name" label='שם משפחה' v-model="form.last_name"></smart-input>
		<smart-input required :error="inputErrors.username" type="text" label='שם משתמש' v-model="form.username"></smart-input>
		<v-checkbox v-if="!isNew" v-model="hidePassword" label="שנה סיסמא"/>
		<smart-input required v-if="hidePassword || isNew" :error="inputErrors.password" type="password" label='סיסמה'
			v-model="form.password" minlength="6"/>
		<v-select
			required
			v-if="form.role == 3"
			v-model="form.company_id"
			:items="companies"
			item-text="name"
			item-value="id"
			label="מרכז"

		/>
		<div class="form-group">
			<v-btn type="submit" color="success">שמירה</v-btn>
		</div>
	</form>
</template>

<script>
	import UserModule from "src/store/modules/User.module";
	import FormView from "src/mixins/FormView";
	import {types as CompaniesTypes} from "src/store/modules/Company.module";
	import OrganizationsSelect from "dev/view/organizations/OrganizationsSelect";
	import {types as roleTypes} from "dev/config/roles";

	export default {
		props: [],
		name: "user-form",
		components: {OrganizationsSelect},
		data() {
			return {
				form: {
					name: null,
					organization_id: null
				},
				roles: [
					{text: "מנהל ארגון", value: 2},
					{text: "משתמש מרכז", value: 3},
				],
				hidePassword: false
			};
		},
		mixins: [new FormView(UserModule, "user")],
		computed: {
			isNew() {
				return !this.user.id;
			},
			isAdmin() {
				return this.$store.getters.isAdmin;
			},
			companies() {
				return this.$store.state.CompanyModule.companies;
			}
		},
		methods: {
			async callSubmit(e) {
				try {
					const submit = await this.onSubmit(e);
				} catch (e) {

				}
			},
			onError() {
				//automatic
			}
		},
		created() {
			this.$store.dispatch(CompaniesTypes.FETCH);
		},
		watch: {
			"form.role"() {
				if (this.role == roleTypes.MANAGER) {
					this.form.organizations = null;
				} else if (this.role == roleTypes.USER) {
					this.form.companies = null;
				}
			}
		}
	};
</script>

<style>

</style>
